<template>
  <div>
    <FloatingButtonMenu
      :menu="[
        {
          icon: 'event_note',
          name: 'EVENT\nLOG',
          component: 'static',
        },
      ]"
      @select="openEventLogHandler"
    />
    <v-dialog v-model="showEventLog" persistent width="90vw">
      <Card>
        <v-toolbar
          height="50px"
          class="sub-header dialog-header elevation-0"
          color="primary"
        >
          <div class="title font-weight-bold text-xs-center">
            {{ $t("EVENT LOGS") }}
          </div>
          <v-spacer />
          <v-icon @click="showEventLog = false" large>close</v-icon>
        </v-toolbar>
        <v-divider />
        <v-layout row justify-end px-4 pt-4 pb-2>
          <v-flex xs2>
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  label="Date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                color="accent"
                v-model="date"
                :max="today"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn flat @click="dateMenu = false">Cancel</v-btn>
                <v-btn flat @click="$refs.menu.save(date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2>
            <v-menu
              ref="time_from_menu"
              v-model="timeFromMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="timeFrom"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="timeFrom"
                  label="Time From"
                  prepend-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="timeFromMenu"
                v-model="timeFrom"
                :max="timeTo"
                full-width
                @click:minute="$refs.time_from_menu.save(timeFrom)"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2>
            <v-menu
              ref="time_to_menu"
              v-model="timeToMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="timeTo"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="timeTo"
                  label="Time To"
                  prepend-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="timeToMenu"
                v-model="timeTo"
                :max="maxTime"
                full-width
                @click:minute="saveTimeHandler"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 text-xs-right>
            <v-btn color="accent" @click="getEventLog()" dark>{{
              $t("APPLY")
            }}</v-btn>
          </v-flex>
        </v-layout>
        <Card class="px-4">
          <v-data-table
            :headers="computedHeader"
            :items="eventLogData"
            class="elevation-1 custom-data-table"
            :pagination.sync="pagination"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  @click="changeSort(header.value)"
                  :class="[
                    'column sortable text-xs-left',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                >
                  {{ header.text }}
                  <v-icon small v-show="header.text != ''">arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <td class="text-xs-left pl-3">{{ props.item.timestamp }}</td>
              <td class="text-xs-left pl-3">{{ props.item.device_id }}</td>
              <td class="text-xs-left pl-3">{{ props.item.device_name }}</td>
              <td class="text-xs-left pl-3">
                {{ props.item.category.toUpperCase() }}
              </td>
              <td
                class="text-xs-left pl-3"
                :class="
                  props.item.prev_status == 'ON' ? 'green--text' : 'red--text'
                "
              >
                {{ props.item.prev_status }}
              </td>
              <td
                class="text-xs-left pl-3"
                :class="
                  props.item.current_status == 'ON'
                    ? 'green--text'
                    : 'red--text'
                "
              >
                {{ props.item.current_status }}
              </td>
              <td class="text-xs-left pl-3">{{ props.item.request_status }}</td>
              <td class="text-xs-left pl-3">{{ props.item.updated_by }}</td>
            </template>
          </v-data-table>
        </Card>
      </Card>
    </v-dialog>
    <v-dialog v-model="dialogPassword" persistent max-width="30%">
      <Card class="pa-3">
        <v-card-title class="title pa-2 justify-center"
          >{{ $t("Enter the Password") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-form class="pa-2">
          {{ $t("Email") }}
          <v-text-field
            class="pa-0"
            v-model="emailId"
            autocomplete="email"
          ></v-text-field>
          {{ $t("Password") }}
          <v-text-field
            class="pa-0"
            type="password"
            v-model="password"
            autocomplete="new-password"
            required
          >
          </v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="error" @click="dialogPassword = false">{{
              $t("Cancel")
            }}</v-btn>
            <v-btn
              class="success"
              @click="
                checkPassword(emailId, password);
                dialogPassword = false;
              "
            >
              {{ $t("OK") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </Card>
    </v-dialog>
    <v-dialog
      v-model="confirmationDialog"
      persistent
      origin="center top"
      max-width="40%"
      class="dialog"
    >
      <Card class="pa-3">
        <v-card-title class="subheading"
          >{{ $t("Are you sure you want to change the state") }}?</v-card-title
        >
        <v-card-actions class="justify-end">
          <v-btn
            color="success"
            v-on:click="
              changeState();
              confirmationDialog = false;
            "
          >
            {{ $t("YES") }}</v-btn
          >
          <v-btn color="error" @click="confirmationDialog = false">{{
            $t("NO")
          }}</v-btn>
        </v-card-actions>
      </Card>
    </v-dialog>
    <v-layout row wrap text-xs-center px-1>
      <v-flex
        xs12
        v-for="(itemList, category) in groupedVcbList"
        :key="category"
      >
        <Card class="px-2 pb-3">
          <div class="subheading px-2 pt-3 pb-2">
            {{ category.toUpperCase() }}
          </div>
          <v-layout row wrap text-xs-center px-2>
            <v-flex xs12 sm4 md3 v-for="item in itemList" :key="item.device_id">
              <Card class="pa-3" :background="'bg'">
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12 pa-2 ma-0>
                    Seleted switch mode:
                    {{ vcbSwitchMode[item.device_id] }}
                  </v-flex>
                  <v-flex xs12 pb-1 ma-0>
                    <v-divider class="custom-divider" />
                  </v-flex>
                  <v-flex xs3>
                    <img
                      class="connected_icon"
                      v-show="vcbConnected[item.etilog_id]"
                      :src="
                        isDark
                          ? require('@/assets/connection/internet_connected.svg')
                          : require('@/assets/connection/internet_connected_light.svg')
                      "
                      width="98%"
                    />
                    <img
                      v-show="!vcbConnected[item.etilog_id]"
                      :src="
                        isDark
                          ? require('@/assets/connection/no_internet.svg')
                          : require('@/assets/connection/no_internet_light.svg')
                      "
                      class="disconnected_icon"
                      width="98%"
                    />
                  </v-flex>
                  <v-flex xs9>
                    <v-layout row wrap>
                      <v-flex class="pt-3 pb-0 mb-0" xs12>
                        <span class="subheading">
                          {{ item.name }}
                        </span>
                      </v-flex>
                      <v-flex class="pt-0 pb-2 mb-0 mt-0" xs12>
                        <span class="caption">
                          {{
                            vcbConnected[item.etilog_id]
                              ? $t("Connection Established")
                              : $t("Connection Lost")
                          }}</span
                        >
                      </v-flex>
                      <v-flex>
                        <a
                          href="#"
                          :id="`${item.device_id}-${item.name}`"
                          class="toggle"
                          :class="
                            vcbConnected[item.etilog_id]
                              ? vcbStatus[item.device_id] &&
                                vcbStatus[item.device_id] === 1
                                ? 'toggle--on'
                                : 'toggle--off'
                              : vcbStatus[item.device_id] &&
                                vcbStatus[item.device_id] === 1
                              ? 'toggle--on disabled'
                              : 'toggle--off disabled'
                          "
                          @click="(e) => toggleHandler(e, item)"
                        ></a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </Card>
            </v-flex>
          </v-layout>
        </Card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const moment = require("moment");
import { mapGetters, mapMutations, mapActions } from "vuex";
import { mapGettersMixin } from "@/util/mixin/index";
import Controlling from "@/services/Controlling";
const FloatingButtonMenu = () =>
  import("@/components/common/FloatingButtonMenu");

export default {
  components: {
    FloatingButtonMenu,
  },
  mixins: [mapGettersMixin],
  data() {
    return {
      dateMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: moment().subtract(15, "minutes").format("HH:mm"),
      timeTo: moment().format("HH:mm"),
      date: new Date().toISOString().substr(0, 10),
      vcbList: [],
      vcbConnected: {},
      vcbStatus: {},
      vcbSwitchMode: {},
      dialogPassword: false,
      confirmationDialog: false,
      showEventLog: false,
      emailId: "",
      password: "",
      currentControlledDevice: {},
      eventLogData: [],
      pagination: {
        sortBy: "Logged on",
        descending: false,
        page: 1,
        rowsPerPage: 500,
      },
    };
  },
  computed: {
    ...mapGetters(["getUserInfo", "getSelectedPlantId"]),
    today() {
      return moment().format("YYYY-MM-DD");
    },
    maxTime() {
      console.log(this.date, "DATE III DATE");
      if (moment().isSame(this.date, "day")) {
        return moment().format("HH:mm");
      } else {
        return "23:59";
      }
    },
    computedHeader() {
      return [
        {
          text: this.$t("Logged on"),
          value: "timestamp",
          align: "left",
        },
        {
          text: this.$t("Device Id"),
          value: "device_id",
          align: "left",
        },
        {
          text: this.$t("Name"),
          value: "device_name",
          align: "left",
        },
        {
          text: this.$t("Category"),
          value: "category",
          align: "left",
        },
        {
          text: this.$t("Prev Status"),
          value: "prev_status",
          align: "left",
        },
        {
          text: this.$t("Current Status"),
          value: "current_status",
          align: "left",
        },
        {
          text: this.$t("Action"),
          value: "request_status",
          align: "left",
        },
        {
          text: this.$t("User"),
          value: "updated_by",
          align: "left",
        },
      ];
    },
    groupedVcbList() {
      const groupedList = _.groupBy(this.vcbList, "category");
      return groupedList;
    },
  },
  async mounted() {
    this.emailId = this.getUserInfo("email");
    this.listenToMqttTopics();

    await this.getVcbList();
    await this.getVcbSwitchMode();
  },
  beforeDestroy() {
    this.unsubscribeToTopics();
  },
  methods: {
    ...mapActions([
      "validateUserAction"
    ]),
    ...mapMutations([
      "SET_SHOW_SNACKBAR",
      "SET_SNACKBAR_CONTENT",
      "SET_PROGRESS_BAR",
    ]),
    async openEventLogHandler() {
      this.showEventLog = true;
      await this.getEventLog();
    },
    saveTimeHandler() {
      this.$refs.time_to_menu.save(this.timeTo);
      if (
        moment(moment(`${this.date} ${this.timeTo}`)).isBefore(
          `${this.date} ${this.timeFrom}`,
          "minutes"
        )
      ) {
        this.timeFrom = this.timeTo;
      }
    },
    listenToMqttTopics() {
      this.$mqtt.subscribe(`control_feedback/${this.getSelectedPlantId}/#`);
      this.$mqtt.subscribe(`epicConnection/${this.getSelectedPlantId}`);
      this.$mqtt.subscribe(`live/${this.getSelectedPlantId}/breaker`);
      this.$mqtt.subscribe(
        `control/state_change/${this.getSelectedPlantId}/breaker`
      );

      this.$mqtt.on("message", async (topic, message) => {
        const payload = JSON.parse(Buffer.from(message).toString());
        if (topic == `epicConnection/${this.getSelectedPlantId}`) {
          const { status, epicId } = payload;
          this.$set(this.vcbConnected, epicId, status);
        } else if (
          topic.startsWith(`control_feedback/${this.getSelectedPlantId}`)
        ) {
          let { device_name, device_id, device_type, status } = payload;

          if (device_type == "breaker") {
            if (this.currentControlledDevice.device_id != device_id) {
              return;
            }
            let param = {
              plant_id: this.getSelectedPlantId,
              device_id,
              device_type,
              category: this.currentControlledDevice.category,
              device_name,
              updated_by: this.emailId,
            };

            let snackbarContent = {
              icon: "",
              header: "",
              message: "",
            };

            if (
              status &&
              ((typeof status == "boolean" && status) ||
                (Array.isArray(status) && status[0] == "true"))
            ) {
              param["prev_status"] = this.vcbStatus[device_id];
              param["current_status"] = this.vcbStatus[device_id] == 1 ? 0 : 1;
              param["request_status"] = "success";
              snackbarContent.icon = "success";
              snackbarContent.message = this.$t(
                "Successfully updated the status"
              );
            } else {
              param["prev_status"] = this.vcbStatus[device_id];
              param["current_status"] = this.vcbStatus[device_id];
              param["request_status"] = "failure";
              snackbarContent.icon = "error";
              snackbarContent.message = this.$t("Failed to update the status");
            }

            this.SET_SNACKBAR_CONTENT(snackbarContent);
            this.SET_SHOW_SNACKBAR(true);

            this.insertLog(param);
          }
        } else if (topic.startsWith("live/")) {
          if (topic.endsWith("breaker")) {
            const mqttData = JSON.parse(message.toString()).deviceList[0];
            if (!mqttData.exception) {
              console.log(mqttData, "MQTT DATA ON BREAKER TOPIC");
              const index = this.vcbList.findIndex(
                (el) => el.device_id == mqttData["device_id"]
              );
              if (index >= 0) {
                let mode = "";
                if (mqttData.remote == 1 && mqttData.local == 0) {
                  mode = "Remote";
                }

                if (
                  (mqttData.remote == 0 && mqttData.local == 1) ||
                  (mqttData.remote == 1 && mqttData.local == 1)
                ) {
                  mode = "Local";
                }

                if (mqttData.remote == null && mqttData.local == null) {
                  mode = "N/A";
                }
                this.$set(this.vcbSwitchMode, mqttData["device_id"], mode);
              }
            }
          }
        } else if (topic.startsWith("control/state_change/")) {
          console.log('STATE CHANGE CAPTURE', payload)
          const { device_id, device_type, etilog_id, state } = payload;
          if (device_type == 'breaker') {
            this.$set(this.vcbStatus, device_id, state);
          }
        }
      });

    },
    unsubscribeToTopics() {
      this.$mqtt.unsubscribe(`control_feedback/${this.getSelectedPlantId}/#`);
      this.$mqtt.unsubscribe(`epicConnection/${this.getSelectedPlantId}`);
      this.$mqtt.unsubscribe(`live/${this.getSelectedPlantId}/breaker`);
      this.$mqtt.unsubscribe(
        `control/state_change/${this.getSelectedPlantId}/breaker`
      );
    },
    clickVCB(deviceDetail) {
      if (this.vcbSwitchMode[deviceDetail.device_id] == "Local") {
        let payload = {
          icon: "error",
          header: "",
          message: this.$t("Operation not allowed!"),
        };
        this.SET_SNACKBAR_CONTENT(payload);
        this.SET_SHOW_SNACKBAR(true);
        return;
      }
      this.currentControlledDevice = {
        name: deviceDetail.name,
        etilog_id: deviceDetail.etilog_id,
        device_id: deviceDetail.device_id,
        device_type: deviceDetail.device_type,
        category: deviceDetail.category,
        interface: deviceDetail.device_interface,
        value: Number(!!!this.vcbStatus[deviceDetail.device_id]),
      };
      if (this.vcbConnected[deviceDetail.etilog_id]) {
        this.dialogPassword = true;
      } else {
        let payload = {
          icon: "error",
          header: "",
          message: this.$t("Sorry Connection Lost with Device"),
        };
        this.SET_SNACKBAR_CONTENT(payload);
        this.SET_SHOW_SNACKBAR(true);
      }
    },
    async checkPassword(email, password) {
      this.emailId = email;
      this.password = password;

      if (password.length <= 1) {
        let payload = {
          icon: "error",
          header: "",
          message: this.$t("Username or password entered is incorrect"),
        };
        this.SET_SNACKBAR_CONTENT(payload);
        this.SET_SHOW_SNACKBAR(true);

        return;
      }

      try {
        await this.validateUserAction({
          email,
          password,
        })
        if (this.vcbConnected[this.currentControlledDevice.etilog_id]) {
          this.confirmationDialog = true;
        } else {
          let payload = {
            icon: "error",
            header: "",
            message: this.$t("Sorry Connection Lost with Device"),
          };
          this.SET_SNACKBAR_CONTENT(payload);
          this.SET_SHOW_SNACKBAR(true);
        }
      } catch (err) {
        console.log(err);
      }
    },
    changeState() {
      const { name, etilog_id, device_id, device_type, value } =
        this.currentControlledDevice;
      let blockPath = device_id.split("-").join("/");
      this.topicValue = `control/${this.getSelectedPlantId}/${etilog_id}/${device_type}/${blockPath}`;

      const msg = {
        plant_id: this.getSelectedPlantId,
        device_id: device_id,
        device_name: name,
        device_type: device_type,
        status: Number(value),
      };
      console.log(msg, "MESSAGE", this.topicValue, "TOPIC **()");
      this.$mqtt.publish(this.topicValue, JSON.stringify(msg));
    },
    async getVcbList() {
      const response = await Controlling.getV2VcbList(this.getSelectedPlantId);
      this.vcbList = response.data.message;
      this.vcbList.forEach((el) => {
        this.$set(this.vcbConnected, el.etilog_id, el.apic_connected);
        this.$set(this.vcbStatus, el.device_id, el.state);
        this.$set(this.vcbSwitchMode, el.device_id, "N/A");
      });
    },
    async getVcbSwitchMode() {
      try {
        const response = await Controlling.getVcbSwitchMode(
          this.getSelectedPlantId
        );
        let list = response.data.message;
        list.forEach((el) => {
          let mode = "";
          if (el.remote == 1 && el.local == 0) {
            mode = "Remote";
          }

          if (
            (el.remote == 0 && el.local == 1) ||
            (el.remote == 1 && el.local == 1)
          ) {
            mode = "Local";
          }

          if (el.remote == null && el.local == null) {
            mode = "N/A";
          }
          this.$set(this.vcbSwitchMode, el.id, mode);
        });
      } catch (err) {
        console.log(err, "ERROR **()**");
      }
    },
    async insertLog(param) {
      console.log(param, "INSERTING IN EVENT LOG");
      const response = await Controlling.insertEventLog(param);
    },
    async getEventLog() {
      const timeFrom = moment(`${this.date} ${this.timeFrom}`).format("X");
      const timeTo = moment(`${this.date} ${this.timeTo}`).format("X");
      const response = await Controlling.fetchEventLog(
        this.getSelectedPlantId,
        this.currentControlledDevice.device_type,
        timeFrom,
        timeTo
      );
      this.eventLogData = response.data.message.map((el) => {
        return {
          timestamp: moment.unix(el.timestamp).format("YYYY-MM-DD HH:mm"),
          device_id: el.device_id,
          device_name: el.device_name,
          category: el.category,
          prev_status: el.prev_status == 1 ? "ON" : "OFF",
          current_status: el.current_status == 1 ? "ON" : "OFF",
          request_status:
            el.request_status.charAt(0).toUpperCase() +
            el.request_status.slice(1),
          updated_by: el.updated_by,
        };
      });
    },
    toggleHandler(e, item) {
      const id = `${item.device_id}-${item.name}`;
      e.preventDefault();
      const tag = document.getElementById(id);

      if (tag.classList.contains("disabled")) {
        return;
      }
      this.clickVCB(item);
    },
    changeSort(column) {
      if (column != "") {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      }
    },
  },

  watch: {
    async getSelectedPlantId() {
      this.unsubscribeToTopics();
      this.listenToMqttTopics();

      await this.getVcbList();
      await this.getVcbSwitchMode();
    },
  },
};
</script>

<style scoped>
.custom-divider {
  background-color: #334079;
}

.toggle {
  position: relative;
  display: block;
  margin: 0 auto;
  width: 90px;
  height: 40px;
  outline: 0;
  text-decoration: none;
  border-radius: 5px;
  border: 2px solid #546e7a;
  background-color: var(--v-bg-base);
  transition: all 500ms;
}

.disabled {
  opacity: 0.3;
}

.disabled:hover {
  cursor: not-allowed;
}

.theme--dark .toggle:active {
  background-color: #1e272e;
}

.theme--light .toggle:active {
  background-color: #455a64;
}

.toggle:hover:not(.toggle--moving):after {
  background-color: #455a64;
}

.toggle:after {
  display: block;
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: calc(50% - 4px);
  line-height: 25px;
  text-align: center;
  text-transform: uppercase;
  font-size: 16px;
  color: white;
  background-color: #000427;
  border: 2px solid;
  transition: all 500ms;
}

.theme--light .toggle:after {
  background-color: #fff;
}

.toggle--on:after {
  content: "On";
  border-radius: 5px 3px 3px 5px;
  color: #3cb371;
}

.toggle--off:after {
  content: "Off";
  border-radius: 3px 5px 5px 3px;
  transform: translate(100%, 0);
  color: #ff5252;
}

.toggle--moving {
  background-color: #1e272e;
}

.theme--light .toggle--moving {
  background-color: #455a64;
}

.toggle--moving:after {
  color: transparent;
  border-color: #4f6c7a;
  background-color: #2b3d44;
  transition: color 0s, transform 500ms, border-radius 500ms,
    background-color 500ms;
}

.custom-data-table {
  height: 71vh;
  overflow-y: auto;
  border-radius: 8px !important;
  border: 1px solid #334079;
}

/* To add vertical lines between columns */
.custom-data-table thead th:not(:last-child),
.custom-data-table tbody td:not(:last-child) {
  border-right: 1px solid #334079;
}

.custom-data-table thead th {
  height: 48px;
  font-size: 14px;
  font-weight: 700 !important;
}

.custom-data-table th {
  z-index: 1;
  position: sticky;
  top: 0;
}

.theme--dark .custom-data-table thead th {
  color: #fff !important;
}

.theme--light .custom-data-table thead th {
  color: #000 !important;
}
</style>
